import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_GROUP_ID,
    ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_ID,
    ACTION_GROUPCONFIDENTIALITYDEED_LOAD_FAILURE,
    ACTION_GROUPCONFIDENTIALITYDEED_LOAD_SUCCESS,

    ACTION_GROUPCONFIDENTIALITYDEED_SAVE,
    ACTION_GROUPCONFIDENTIALITYDEED_SAVE_SUCCESS,
    ACTION_GROUPCONFIDENTIALITYDEED_SAVE_FAILURE,

    ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE,
    ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE_SUCCESS,
    ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE_FAILURE,

    ACTION_GROUPCONFIDENTIALITYDEED_CREATE,
    ACTION_GROUPCONFIDENTIALITYDEED_CREATE_SUCCESS,
    ACTION_GROUPCONFIDENTIALITYDEED_CREATE_FAILURE,

    ACTION_GROUPCONFIDENTIALITYDEED_DELETE,
    ACTION_GROUPCONFIDENTIALITYDEED_DELETE_SUCCESS,
    ACTION_GROUPCONFIDENTIALITYDEED_DELETE_FAILURE,

    ACTION_GROUPCONFIDENTIALITYDEED_SYNC,
    ACTION_GROUPCONFIDENTIALITYDEED_SYNC_SUCCESS,
    ACTION_GROUPCONFIDENTIALITYDEED_SYNC_FAILURE,

    ACTION_GROUPCONFIDENTIALITYDEED_CLEAR,
    ACTION_GROUPCONFIDENTIALITYDEED_FILTER,

    GroupConfidentialityDeedAction
} from '../actions/groupConfidentialityDeed';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface IGroupConfidentialityDeedState {
    formData: Dtos.GroupConfidentialityDeed | Dtos.GroupConfidentialityDeed[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    validateState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    deleteState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.GroupConfidentialityDeed[];
    formLength: number;
}

const initialState: IGroupConfidentialityDeedState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    deleteState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: IGroupConfidentialityDeedState, _isLoading: boolean): IGroupConfidentialityDeedState {
    const newState: IGroupConfidentialityDeedState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: IGroupConfidentialityDeedState,
    formData: Dtos.GroupConfidentialityDeed | Dtos.GroupConfidentialityDeed[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IGroupConfidentialityDeedState {
    const newState: IGroupConfidentialityDeedState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function loadFailure(state: IGroupConfidentialityDeedState, responseStatus: Dtos.ResponseStatus): IGroupConfidentialityDeedState {
    const newState: IGroupConfidentialityDeedState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function filter(state: IGroupConfidentialityDeedState, formFilter: IFormFilter): IGroupConfidentialityDeedState {

    const items: Dtos.GroupConfidentialityDeed[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = items ? items.length : 0;

    const formFilteredData = items ? items.filter(p => (p.active == true || formFilter.showInActive) &&
        (
            formFilter.search == "" ||
            p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1
        )) : undefined;

    const newState: IGroupConfidentialityDeedState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function clear(state: IGroupConfidentialityDeedState, propertiesToClear?: string[]): IGroupConfidentialityDeedState {

    if (!propertiesToClear) {
        const newState: IGroupConfidentialityDeedState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: IGroupConfidentialityDeedState, _isSaving: boolean): IGroupConfidentialityDeedState {
    const newState: IGroupConfidentialityDeedState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IGroupConfidentialityDeedState,
    formData: Dtos.GroupConfidentialityDeed | Dtos.GroupConfidentialityDeed[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IGroupConfidentialityDeedState {
    const newState: IGroupConfidentialityDeedState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IGroupConfidentialityDeedState, responseStatus: Dtos.ResponseStatus): IGroupConfidentialityDeedState {
    const newState: IGroupConfidentialityDeedState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function validating(state: IGroupConfidentialityDeedState, _isValidating: boolean): IGroupConfidentialityDeedState {
    const newState: IGroupConfidentialityDeedState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: IGroupConfidentialityDeedState,
    formData: Dtos.GroupConfidentialityDeed | Dtos.GroupConfidentialityDeed[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IGroupConfidentialityDeedState {
    const newState: IGroupConfidentialityDeedState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: IGroupConfidentialityDeedState, responseStatus: Dtos.ResponseStatus): IGroupConfidentialityDeedState {
    const newState: IGroupConfidentialityDeedState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: IGroupConfidentialityDeedState, _isCreating: boolean): IGroupConfidentialityDeedState {
    const newState: IGroupConfidentialityDeedState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IGroupConfidentialityDeedState,
    formData: Dtos.GroupConfidentialityDeed,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): IGroupConfidentialityDeedState {
    const newState: IGroupConfidentialityDeedState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IGroupConfidentialityDeedState, responseStatus: Dtos.ResponseStatus): IGroupConfidentialityDeedState {
    const newState: IGroupConfidentialityDeedState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function deleting(state: IGroupConfidentialityDeedState, _isDeleting: boolean): IGroupConfidentialityDeedState {
    const newState: IGroupConfidentialityDeedState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function deleteSuccess(
    state: IGroupConfidentialityDeedState,
): IGroupConfidentialityDeedState {
    const newState: IGroupConfidentialityDeedState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function deleteFailure(state: IGroupConfidentialityDeedState, responseStatus: Dtos.ResponseStatus): IGroupConfidentialityDeedState {
    const newState: IGroupConfidentialityDeedState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

const GroupConfidentialityDeedReducer: Reducer<IGroupConfidentialityDeedState> = (state: IGroupConfidentialityDeedState = initialState, action: GroupConfidentialityDeedAction) => {
    switch (action.type) {
        case ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_GROUP_ID:
        case ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_GROUPCONFIDENTIALITYDEED_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_GROUPCONFIDENTIALITYDEED_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_GROUPCONFIDENTIALITYDEED_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_GROUPCONFIDENTIALITYDEED_SAVE:
            return saving(state, true);
        case ACTION_GROUPCONFIDENTIALITYDEED_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_GROUPCONFIDENTIALITYDEED_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE:
            return validating(state, true);
        case ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_GROUPCONFIDENTIALITYDEED_CREATE:
            return creating(state, true);
        case ACTION_GROUPCONFIDENTIALITYDEED_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_GROUPCONFIDENTIALITYDEED_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_GROUPCONFIDENTIALITYDEED_DELETE:
            return deleting(state, true);
        case ACTION_GROUPCONFIDENTIALITYDEED_DELETE_SUCCESS:
            return deleteSuccess(state);
        case ACTION_GROUPCONFIDENTIALITYDEED_DELETE_FAILURE:
            return deleteFailure(state, action.responseStatus);
        case ACTION_GROUPCONFIDENTIALITYDEED_FILTER:
            return filter(state, action.formFilter);
        case ACTION_GROUPCONFIDENTIALITYDEED_SYNC:
            return loading(state, true);
        case ACTION_GROUPCONFIDENTIALITYDEED_SYNC_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_GROUPCONFIDENTIALITYDEED_SYNC_FAILURE:
            return loadFailure(state, action.responseStatus);

    }

    return state;
}

export default GroupConfidentialityDeedReducer;